var map = {
	"./de/invite.svg": 47379,
	"./en/invite.svg": 92651,
	"./es/invite.svg": 13880,
	"./fr/invite.svg": 87364,
	"./it/invite.svg": 38193,
	"./ko/invite.svg": 69570,
	"./pl/invite.svg": 17224,
	"./pt/invite.svg": 98848,
	"./ru/invite.svg": 96445,
	"./tr/invite.svg": 79378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58726;